module.exports = __webpack_public_path__ + "static/media/Helvetica.1b580d98.ttf";